import {useMemo} from 'react'
import {useTable, Column, HeaderGroup, Row, Cell} from 'react-table'

type LyraRow = {
  Unidad: string
  Admision_Rol_Clinica: string
  Cod_Cama: string
  Nombre_Paciente: string
  Tipo_Medico: string
  Resp_Consumo: string
  Fecha_Registro: string
  Prestacion_Codigo_Prestacion: string
  Carga_Visita: number | string
  Motivo: string
  Respuesta: string
}

type ITableVisits = {
  data: LyraRow[]
  loading: boolean
  searched: boolean
}

const Table = ({data, loading, searched}: ITableVisits) => {
  const columns: Column<LyraRow>[] = useMemo(
    () => [
      {
        Header: 'DATOS PACIENTE',
        columns: [
          {Header: 'UNIDAD', accessor: 'Unidad'},
          {Header: 'ID INGRESO', accessor: 'Admision_Rol_Clinica'},
          {Header: 'COD. CAMA', accessor: 'Cod_Cama'},
          {Header: 'NOMBRE', accessor: 'Nombre_Paciente'},
        ],
      },
      {
        Header: ' ',
        columns: [
          {Header: 'TIPO MÉDICO', accessor: 'Tipo_Medico',
            Cell: ({value}: any) => {
              if (value === 'MIC') return 'Interconsultor';
              if (value === 'MT') return 'Tratante';
              return value;
            },
          },
          {Header: 'RESP. CONSUMO', accessor: 'Resp_Consumo'},
          {Header: 'FECHA REGISTRO', accessor: 'Fecha_Registro'},
          {Header: 'PRESTACIÓN', accessor: 'Prestacion_Codigo_Prestacion'},
          {
            Header: 'ENVÍO A VALORIZACIÓN',
            accessor: 'Carga_Visita',
            Cell: ({value}: any) => (Number(value) === 1 ? 'SI' : 'NO'),
          },
          {Header: 'MOTIVO', accessor: 'Motivo'},
          {Header: 'RESPUESTA', accessor: 'Respuesta'},
        ],
      },
    ],
    []
  )

  const {getTableProps, getTableBodyProps, headerGroups, rows, prepareRow} = useTable({
    columns,
    data,
  })

  const emptyMessage = searched ? 'NO SE ENCONTRARON REGISTROS' : 'REALICE UNA BÚSQUEDA'

  return (
    <div className='card-body py-5'>
      <div className='table-responsive'>
        <table
          className='table table-striped table-hover table-bordered align-middle gs-0 gy-3'
          {...getTableProps()}
        >
          <thead>
            {headerGroups.map((headerGroup: HeaderGroup<LyraRow>) => (
              <tr
                {...headerGroup.getHeaderGroupProps()}
                className='text-center fs-6 fw-bold bg-primaryamsm text-white'
              >
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()} className='px-3 py-4 border'>
                    {column.render('Header')}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          {!loading && (
            <tbody {...getTableBodyProps()} className='fs-6 text-gray-800'>
              {rows.length > 0 ? (
                rows.map((row: Row<LyraRow>) => {
                  prepareRow(row)
                  return (
                    <tr {...row.getRowProps()} className='border-bottom'>
                      {row.cells.map((cell: Cell<LyraRow>) => (
                        <td {...cell.getCellProps()} className='px-3'>
                          {cell.render('Cell')}
                        </td>
                      ))}
                    </tr>
                  )
                })
              ) : (
                <tr>
                  <td colSpan={16} className='text-center py-10 text-muted fs-5'>
                    {emptyMessage}
                  </td>
                </tr>
              )}
            </tbody>
          )}
        </table>

        {loading && (
          <div className='text-center text-primary w-100'>
            <div className='spinner-border text-primary'></div>
            <div className='fs-6 fw-bold'>CARGANDO VISITAS...</div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Table
